

































































































































































































import { Component, Vue } from "vue-property-decorator";
import viewBox from "@/components/viewBox.vue";
import wetlandpark from "@/common/wetlandpark";
import { Overlay, Toast } from "vant";
import request from "@/api/index";
import html2canvas from "html2canvas";
import Native from "@/common/Native";
import { isOpenInWechat } from "@/common/Utils";

@Component({
  components: { viewBox, vanOverlay: Overlay }
})
export default class Cultivation extends Vue {
  // 浇水图片
  wateringImg: any = [
    require("../assets/images/cultivation/watering.png"),
    require("../assets/images/cultivation/watering.gif")
  ];
  wateringImgIndex = 0;
  // 用户种子信息
  userCultivationInfo: any = null;
  //seedId 1 水仙 2 鸢尾 3 睡莲
  //seedLevel 0 种子 12花苞 34开花
  // 用户参与位数
  number = 0;
  // 用户剩余答题次数
  statistics: any = {};
  // 显示页面
  showpage = false;
  showbtn = true;
  // 海报图片 base64
  haobaoimg: any = null;
  // 景区图片 网络图片转base64
  jinquimgthumb64: any = null;
  // 弹框
  show = false;
  postershow = false;
  advertisingshow = false;
  wetlandpark: any = [];
  flowerConfig: any = [
    [
      [
        require("../assets/images/cultivation/shuixian1.png"),
        require("../assets/images/cultivation/shuixian1.png")
      ],
      [
        require("../assets/images/cultivation/shuixian1.png"),
        require("../assets/images/cultivation/shuixian1.png")
      ],
      [
        require("../assets/images/cultivation/shuixian2.png"),
        require("../assets/images/cultivation/shuixian2.gif")
      ],
      [
        require("../assets/images/cultivation/shuixian2.png"),
        require("../assets/images/cultivation/shuixian2.png")
      ],
      [
        require("../assets/images/cultivation/shuixian3.png"),
        require("../assets/images/cultivation/shuixian3.gif")
      ]
    ],
    [
      [
        require("../assets/images/cultivation/yuanwei1.png"),
        require("../assets/images/cultivation/yuanwei1.png")
      ],
      [
        require("../assets/images/cultivation/yuanwei1.png"),
        require("../assets/images/cultivation/yuanwei1.png")
      ],
      [
        require("../assets/images/cultivation/yuanwei2.png"),
        require("../assets/images/cultivation/yuanwei2.gif")
      ],
      [
        require("../assets/images/cultivation/yuanwei2.png"),
        require("../assets/images/cultivation/yuanwei2.png")
      ],
      [
        require("../assets/images/cultivation/yuanwei3.png"),
        require("../assets/images/cultivation/yuanwei3.gif")
      ]
    ],
    [
      [
        require("../assets/images/cultivation/shuilian1.png"),
        require("../assets/images/cultivation/shuilian1.png")
      ],
      [
        require("../assets/images/cultivation/shuilian1.png"),
        require("../assets/images/cultivation/shuilian1.png")
      ],
      [
        require("../assets/images/cultivation/shuilian2.png"),
        require("../assets/images/cultivation/shuilian2.gif")
      ],
      [
        require("../assets/images/cultivation/shuilian2.png"),
        require("../assets/images/cultivation/shuilian2.png")
      ],
      [
        require("../assets/images/cultivation/shuilian3.png"),
        require("../assets/images/cultivation/shuilian3.gif")
      ]
    ]
  ];
  huaImgIndex = 0;
  // 广告栏
  advertisingConfig: Array<string> = [
    require("../assets/images/cultivation/advertising1.png"),
    require("../assets/images/cultivation/advertising2.png"),
    require("../assets/images/cultivation/advertising3.png")
  ];
  advertisingIndex = 0;
  isapp = false;
  iswx = false;
  btnloding = true;
  mounted() {
    document.title = "培育";
    this.advertisingIndex = this.getRandomArray();
    if (Native.isOpenInApp()) {
      this.isapp = true;
    } else if (isOpenInWechat()) {
      this.iswx = true;
    } else {
      console.log("h5打开");
    }
    this.getseed();
    this.getnumber();
    this.getstatistics();
  }
  async getnumber() {
    const res = await request.getnumber();
    if (!res.code) {
      this.number = res.data;
    }
  }
  async getstatistics() {
    const res = await request.getstatistics();
    if (!res.code) {
      this.statistics = res.data;
    }
  }
  async gewatering() {
    if (this.userCultivationInfo.seedLevel >= 5) return;
    const res = await request.gewatering();
    if (!res.code) {
      this.getseed(true);
      this.userCultivationInfo.seedLevel++;
      this.huaImgIndex = 1;
      setTimeout(() => {
        this.huaImgIndex = 0;
      }, 2000);
    } else {
      Toast(res.message);
    }
  }
  async getseed(flag = false) {
    const res = await request.getseed();
    if (!res.code) {
      this.userCultivationInfo = res.data;
      this.showpage = true;
      if (this.userCultivationInfo.seedLevel > 5) {
        this.userCultivationInfo.seedLevel = 5;
      }
      if (this.userCultivationInfo.seedLevel == 5) {
        this.showbtn = false;
      }
      if (flag && this.userCultivationInfo.seedLevel == 5) {
        this.advertisingIndex = this.getRandomArray();
        this.advertisingshow = true;
      } else {
        this.ImageToBase64();
      }
    }
  }
  noanswer() {
    Toast("请明日再来参与答题");
  }
  watering() {
    if (this.userCultivationInfo.water < 5) {
      this.show = true;
      return;
    }
    if (!this.btnloding) return;
    this.btnloding = false;
    this.wateringImgIndex = 1;
    setTimeout(() => {
      this.wateringImgIndex = 0;
      this.gewatering();
    }, 1000);
  }
  getRandomArray() {
    const index = Math.floor(Math.random() * this.advertisingConfig.length);
    return index;
  }
  //将网络图片转化为Base64
  ImageToBase64() {
    //一定要设置为let，不然图片不显示，下面解释↓
    const image = new Image();
    //解决跨域问题
    image.setAttribute("crossOrigin", "anonymous");
    //this.invincibleData.thumb这里是网络图片路径，
    //比如：https://down.yantongtech.cn/data/upload/images/2021-03-29/8567a979ba7ab9fd94e49866f095b9e5.jpg?1617081289278
    image.src = this.userCultivationInfo.parkImg;

    //image.onload为异步加载
    image.onload = () => {
      const canvas = this.$refs.headCanvas as any;
      const context = canvas.getContext("2d");
      canvas.width = image.width;
      canvas.height = image.height;
      context.drawImage(image, 0, 0, image.width, image.height);
      const dataurl = canvas.toDataURL("image/png");
      //得到64位格式
      this.jinquimgthumb64 = dataurl;
    };
  }
  share() {
    this.haobaoimg = null;
    this.postershow = true;
    setTimeout(() => {
      html2canvas(this.$refs.imageDom as any).then(canvas => {
        //将对应dom组件转成图片并生成图片地址
        const imgUrl = canvas.toDataURL();
        this.haobaoimg = imgUrl;
      });
    }, 10);
  }
  save() {
    if (this.isapp) {
      this.postershow = false;
      window.ZWY_CLOUD.saveToAlbum({
        ImageAddress: this.haobaoimg
      });
    } else if (this.iswx) {
      this.postershow = false;
    } else {
      console.log("h5打开");
    }
  }
  checkswip(type: string) {
    if (type == "left") {
      (this.$refs["swipe"] as any).prev();
    }
    if (type == "right") {
      (this.$refs["swipe"] as any).next();
    }
  }
  gettext(type: string) {
    for (let i = 0; i < wetlandpark.length; i++) {
      if (wetlandpark[i].id == this.userCultivationInfo.parkId) {
        if (type == "1") {
          return wetlandpark[i].text1img;
        }
        if (type == "2") {
          return wetlandpark[i].text2img;
        }
      }
    }
  }
  topage(path: string) {
    this.$router.push(path);
  }
}
